export default {"src":"/_next/static/media/communication.7e3b5bda.svg","height":45,"width":50,"blurWidth":0,"blurHeight":0};